function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0543 34.025C11.0543 36.5826 12.8774 38.0799 14.8634 38.0799C16.1548 38.0799 16.9036 37.4023 16.9036 37.4023H16.9253C16.9253 37.4023 16.9144 37.5662 16.9144 37.7301V37.9487H18.4989V33.5332H15.7207V35.1617H16.8168V35.7628C16.8168 35.7628 16.1548 36.3312 15.2432 36.3312C14.0386 36.3312 13.0185 35.4459 13.0185 33.9595C13.0185 32.8009 13.6805 31.7517 15.3083 31.7517C16.4044 31.7517 17.1966 32.4731 17.1966 32.4731L18.1082 31.0413C18.1082 31.0413 17.1098 30.003 15.1238 30.003C12.7581 30.003 11.0543 31.7517 11.0543 34.025Z",
  fill: "#24292E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1433 37.9487H25.2113V36.3093H22.0425V30.1341H20.1433V37.9487Z",
  fill: "#24292E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8906 33.9923C25.8906 36.2875 27.6052 38.0799 29.9493 38.0799C32.2934 38.0799 34.008 36.2875 34.008 33.9923C34.008 31.7517 32.2934 30.003 29.9493 30.003C27.6052 30.003 25.8906 31.7517 25.8906 33.9923ZM27.8548 33.9923C27.8548 32.7135 28.7881 31.7517 29.9493 31.7517C31.1105 31.7517 32.0438 32.7135 32.0438 33.9923C32.0438 35.3257 31.1105 36.3312 29.9493 36.3312C28.7881 36.3312 27.8548 35.3257 27.8548 33.9923Z",
  fill: "#24292E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5204 37.9487H38.3745C39.9155 37.9487 41.3263 37.3258 41.3263 35.6208C41.3263 34.9322 41.0007 34.1343 40.1109 33.8611V33.8392C40.6969 33.5004 41.0116 32.8337 41.0116 32.178C41.0116 30.8336 39.9264 30.1341 38.3745 30.1341H35.5204V37.9487ZM37.4195 33.1616V31.7736H38.3637C38.8737 31.7736 39.0799 32.0796 39.0799 32.4403C39.0799 32.8119 38.8737 33.1616 38.3962 33.1616H37.4195ZM37.4195 36.3093V34.6917H38.5698C39.1233 34.6917 39.3838 35.0524 39.3838 35.4896C39.3838 35.9268 39.1125 36.3093 38.559 36.3093H37.4195Z",
  fill: "#24292E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.2536 37.9487H49.2069L46.5699 30.1341H44.5731L41.936 37.9487H43.8894L44.356 36.3093H46.7761L47.2536 37.9487ZM45.5823 31.9157C45.5823 31.9157 45.7559 32.7682 45.897 33.26L46.3311 34.7792H44.801L45.2459 33.26C45.387 32.7682 45.5606 31.9157 45.5606 31.9157H45.5823Z",
  fill: "#24292E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M50.2934 37.9487H55.3613V36.3093H52.1925V30.1341H50.2934V37.9487Z",
  fill: "#24292E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3223 37.9487H61.2214V30.1341H59.3223V37.9487Z",
  fill: "#24292E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M64.7459 37.9487H66.6451V31.7736H69V30.1341H62.391V31.7736H64.7459V37.9487Z",
  fill: "#24292E"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11 48.8882C11 48.8882 12.0093 50.003 13.8324 50.003C15.5796 50.003 16.5672 48.8773 16.5672 47.5766C16.5672 45.1066 13.0728 45.2814 13.0728 44.2978C13.0728 43.8606 13.5069 43.6857 13.8975 43.6857C14.8308 43.6857 15.6122 44.3743 15.6122 44.3743L16.4152 42.8114C16.4152 42.8114 15.5905 41.9261 13.9192 41.9261C12.3782 41.9261 11.1736 42.877 11.1736 44.3196C11.1736 46.7241 14.668 46.6914 14.668 47.6204C14.668 48.0903 14.2448 48.2433 13.8541 48.2433C12.8774 48.2433 11.9984 47.4346 11.9984 47.4346L11 48.8882Z",
  fill: "#24292E"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9788 46.9974C17.9788 48.757 19.2594 50.003 21.2345 50.003C23.1879 50.003 24.4684 48.757 24.4684 46.9974V42.0572H22.5693V46.9974C22.5693 47.8171 22.0375 48.2543 21.2236 48.2543C20.4097 48.2543 19.8779 47.8171 19.8779 46.9974V42.0572H17.9788V46.9974Z",
  fill: "#24292E"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4011 49.8718H28.3003V47.4564H29.6242C31.1327 47.4564 32.1528 46.3197 32.1528 44.7459C32.1528 43.1721 31.1327 42.0572 29.6242 42.0572H26.4011V49.8718ZM28.3003 45.817V43.6967H29.2661C29.8955 43.6967 30.2211 44.1229 30.2211 44.7459C30.2211 45.3689 29.8955 45.817 29.2336 45.817H28.3003Z",
  fill: "#24292E"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4962 49.8718H35.3953V47.4564H36.7193C38.2277 47.4564 39.2479 46.3197 39.2479 44.7459C39.2479 43.1721 38.2277 42.0572 36.7193 42.0572H33.4962V49.8718ZM35.3953 45.817V43.6967H36.3612C36.9906 43.6967 37.3162 44.1229 37.3162 44.7459C37.3162 45.3689 36.9906 45.817 36.3286 45.817H35.3953Z",
  fill: "#24292E"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0595 45.9154C40.0595 48.2106 41.7741 50.003 44.1182 50.003C46.4623 50.003 48.1769 48.2106 48.1769 45.9154C48.1769 43.6748 46.4623 41.9261 44.1182 41.9261C41.7741 41.9261 40.0595 43.6748 40.0595 45.9154ZM42.0237 45.9154C42.0237 44.6366 42.957 43.6748 44.1182 43.6748C45.2794 43.6748 46.2127 44.6366 46.2127 45.9154C46.2127 47.2488 45.2794 48.2543 44.1182 48.2543C42.957 48.2543 42.0237 47.2488 42.0237 45.9154Z",
  fill: "#24292E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6893 49.8718H51.5884V47.2378H52.4783L53.8565 49.8718H55.9727L54.4642 47.1395C54.2798 46.8116 54.1712 46.6695 54.1712 46.6695V46.6476C54.9417 46.2542 55.3324 45.347 55.3324 44.5164C55.3324 43.3797 54.779 42.5819 53.8999 42.243C53.5635 42.1119 53.1837 42.0572 52.3915 42.0572H49.6893V49.8718ZM51.5884 45.5984V43.6967H52.2287C53.1837 43.6967 53.4007 44.0464 53.4007 44.6366C53.4007 45.2596 53.0209 45.5984 52.4132 45.5984H51.5884Z",
  fill: "#24292E"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M58.8222 49.8718H60.7213V43.6967H63.0762V42.0572H56.4672V43.6967H58.8222V49.8718Z",
  fill: "#24292E"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H80V34H76V4H4V76H76V57.5781L63.6579 64.4349L61.7153 60.9383L80 50.7801V80H0V0Z",
  fill: "#66BB6A"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2d76ac32.svg";
export { ForwardRef as ReactComponent };